import { AppBundle } from 'api/optimalprint-sdk.d';
import { cloneDeep } from 'lodash';

const sumPrices = (...prices: (AppBundle.Api.Entity.Product.V1.IProductPrice | undefined)[]) => {
  if (!prices[0]) {
    return undefined;
  }
  const sum = cloneDeep(prices[0]);
  for (let i = 1; i < prices.length; i += 1) {
    const price = prices[i];
    if (!price) {
      // eslint-disable-next-line no-continue
      continue;
    }

    sum.ip += price.ip;
    sum.ipi += price.ipi;
    sum.nip += price.nip;
    sum.np += price.np;
    sum.p += price.p;
    sum.pi += price.pi;
  }
  return sum as AppBundle.Api.Entity.Product.V1.IProductPrice | undefined;
};

export default sumPrices;
